import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Transition as _Transition, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open user menu", -1)
const _hoisted_2 = { class: "mx-2 w-28 flex-1 md:flex-none font-medium truncate overflow-ellipsis" }
const _hoisted_3 = {
  key: 0,
  class: "self-center m-1 px-1.5 py-1 text-center bg-red-700 text-white text-sm rounded-sm shadow-sm truncate"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Not a contract ")
const _hoisted_6 = {
  key: 1,
  class: "self-center m-1 mb-3 px-1.5 py-1 text-center bg-pink-700 text-white text-sm rounded-sm shadow-sm"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Overview ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "The selected account is inaccessible.", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Keys may have stopped working. Try signing out and signing back in. "),
  /*#__PURE__*/_createElementVNode("li", null, " The account may be on a different network (e.g. testnet account on mainnet or vice-versa). Try changing the active network. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserCircleIcon = _resolveComponent("UserCircleIcon")!
  const _component_ExclamationCircleIcon = _resolveComponent("ExclamationCircleIcon")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_client_only = _resolveComponent("client-only")!

  return (_openBlock(), _createBlock(_component_client_only, null, {
    default: _withCtx(() => [
      _createVNode(_component_Menu, _mergeProps({ as: "div" }, _ctx.$attrs, { class: "relative flex flex-1 justify-end" }), {
        default: _withCtx(() => [
          _createVNode(_component_MenuButton, { class: "rounded-full flex-1 md:flex-none flex items-center bg-white border border-gray-300 dark:border-transparent hover:bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-800 py-1 px-2" }, {
            default: _withCtx(() => [
              _hoisted_1,
              (_ctx.walletAuth.isAccessible)
                ? (_openBlock(), _createBlock(_component_UserCircleIcon, {
                    key: 0,
                    class: "w-7 h-7"
                  }))
                : _createCommentVNode("", true),
              (!_ctx.walletAuth.isAccessible)
                ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                    key: 1,
                    class: "w-7 h-7 text-orange-400"
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.walletAuth.isSignedIn ? _ctx.walletAuth.accountId : 'Account'), 1),
              _createVNode(_component_ChevronDownIcon, { class: "w-5 h-5" })
            ]),
            _: 1
          }),
          _createVNode(_Transition, {
            "enter-active-class": "transition ease-out duration-100",
            "enter-from-class": "transform opacity-0 scale-95",
            "enter-to-class": "transform opacity-100 scale-100",
            "leave-active-class": "transition ease-in duration-75",
            "leave-from-class": "transform opacity-100 scale-100",
            "leave-to-class": "transform opacity-0 scale-95"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_MenuItems, { class: "origin-top-right absolute z-20 right-0 top-full mt-2 w-64 flex flex-col rounded-sm shadow-lg bg-white dark:bg-gray-700 border dark:border-gray-600 ring-1 ring-black ring-opacity-5 py-1 focus:outline-none" }, {
                default: _withCtx(() => [
                  (!_ctx.canSignIn)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createTextVNode(" Cannot log in to " + _toDisplayString(_ctx.account), 1),
                        _hoisted_4,
                        _hoisted_5
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.walletAuth.isSignedIn && _ctx.canSignIn)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Interact with contract "))
                    : _createCommentVNode("", true),
                  (!_ctx.walletAuth.isAccessible)
                    ? (_openBlock(), _createBlock(_component_MenuItem, {
                        key: 2,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isAccountErrorModalOpen = true))
                      }, {
                        default: _withCtx(({ active }) => [
                          _createElementVNode("button", {
                            class: _normalizeClass(["my-1 mx-4 text-center px-2 py-1 font-medium rounded-sm bg-opacity-30 dark:bg-opacity-40 border border-orange-400 dark:border-orange-600 cursor-pointer", [
                active
                  ? 'bg-orange-500 text-orange-900 dark:bg-orange-600 dark:text-white'
                  : 'bg-orange-200 text-orange-800 dark:bg-orange-800 dark:text-orange-100',
              ]])
                          }, " Account error ", 2)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.walletAuth.isSignedIn)
                    ? (_openBlock(), _createBlock(_component_MenuItem, { key: 3 }, {
                        default: _withCtx(({ active }) => [
                          _createVNode(_component_router_link, {
                            as: "a",
                            class: _normalizeClass(_ctx.userMenuItemClass(active)),
                            to: {
                name: 'overview',
                params: {
                  account: _ctx.walletAuth.accountId,
                  network: _ctx.network,
                },
                query: {
                  t: _ctx.timeframe,
                },
              }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 2
                          }, 1032, ["class", "to"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.walletAuth.isSignedIn)
                    ? (_openBlock(), _createBlock(_component_MenuItem, {
                        key: 4,
                        onClick: _ctx.signOut
                      }, {
                        default: _withCtx(({ active }) => [
                          _createElementVNode("a", {
                            href: "#",
                            class: _normalizeClass(_ctx.userMenuItemClass(active))
                          }, "Sign out", 2)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (!_ctx.walletAuth.isSignedIn && _ctx.canSignIn)
                    ? (_openBlock(), _createBlock(_component_MenuItem, {
                        key: 5,
                        onClick: _ctx.signIn
                      }, {
                        default: _withCtx(({ active }) => [
                          _createElementVNode("a", {
                            href: "#",
                            class: _normalizeClass(_ctx.userMenuItemClass(active))
                          }, "Use " + _toDisplayString(_ctx.account), 3)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 16),
      (!_ctx.walletAuth.isAccessible)
        ? (_openBlock(), _createBlock(_component_Modal, {
            key: 0,
            open: _ctx.isAccountErrorModalOpen,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isAccountErrorModalOpen = false)),
            title: "Account error",
            prose: ""
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _hoisted_9
            ]),
            _: 1
          }, 8, ["open"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}